<template>
  <a-form-item
    class="form-question-field stc-ant-field-skin"
    label="Ваш вопрос"
    name="question"
    required
  >
    <a-textarea
      class="form-question-field__textarea"
      :value="modelValue"
      :maxlength="maxLength"
      rows="4"
      placeholder="Опишите ваш вопрос подробно"
      @update:value="emit('update:modelValue', $event)"
    />
    <div class="form-question-field__counter">
      {{ modelValue.length }} / {{ maxLength }}
    </div>
  </a-form-item>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  modelValue: string;
  maxLength?: number;
}>(), {
  maxLength: 512,
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>

<style scoped>
.form-question-field__counter {
  margin-top: 8px;
  text-align: right;
  font-size: 12px;
  line-height: 1.2;
  color: var(--stc-gray-400);
}
</style>
